'use client';

import { ChangeEvent, FC } from 'react';

import { RangeInputs } from '@/components/ui/RangeInputs/RangeInputs';
import { RangeSlider } from '@/components/ui/RangeSlider/RangeSlider';
import { LimitTypesEnum } from '@/constants/common';

interface RangeGroupProps {
  min: number;
  max: number;
  label: string;
  onChange: (value: number) => void;
  onBlur: () => void;
  step?: number;
  type: LimitTypesEnum;
  value: number;
  isTouched: boolean;
}

export const RangeGroup: FC<RangeGroupProps> = ({
  min,
  max,
  label,
  type,
  isTouched,
  onChange,
  onBlur,
  step = 1,
  value
}) => {
  const isActive = value !== min;

  const handleChange = (e: ChangeEvent<HTMLInputElement> | string | number) => {
    const computedValue = typeof e === 'object' ? e.target.value : e;
    onChange(Number(computedValue));
  };

  return (
    <div style={{ margin: '0 auto', width: '100%' }}>
      <RangeInputs
        type={type}
        label={label}
        isChanged={isTouched}
        value={value}
        onChange={handleChange}
        onBlur={onBlur}
        min={min}
        max={max}
      />
      <RangeSlider
        type={type}
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={handleChange}
        onBlur={onBlur}
        isActive={isActive}
      />
    </div>
  );
};
